import React from 'react';
import { ResetPasswordForm } from '@features/auth/components/reset-password/ResetPasswordForm';

const ResetPasswordPage: React.FC = () => {
  return <ResetPasswordForm />;
};

export default ResetPasswordPage;
